import React from 'react';
import { ConfidentialLevel } from '../../../types/api/ConfidentialLevel';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Namespace } from '../../../translation/namespace';

type ConfidentialLevelProps = { confidentialLevel: ConfidentialLevel };

export function ConfidentialLevelDefinition({ confidentialLevel }: ConfidentialLevelProps) {
  const { t } = useSonTranslation('phrases');
  return (
    <p className="page-meta-info__classification-wrapper">
      <dfn className="page-meta-info__dfn invisible">{`${t(`${Namespace.glossary}:classification`)}: `}</dfn>
      <span className="page-meta-info__classification font-bold-15-19">
        {/* overwriting text via aria-label to avoid automated spelling in screen readers,
        because text is written uppercase. additionally needs a role. */}
        <span role="definition" aria-label={t(`securityClearance.${confidentialLevel}.ariaLabel`)}>
          {t(`securityClearance.${confidentialLevel}.text`)}
        </span>
      </span>
    </p>
  );
}
